"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = exports.Tabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _shared = require("@widget-editor/shared");

var _style = require("./style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var TabButton = function TabButton(props) {
  return _react["default"].createElement(_shared.Button, _extends({
    style: {
      height: "100%"
    }
  }, props));
};

var Tabs = function Tabs(_ref) {
  var children = _ref.children;
  var validChildren = (0, _react.useMemo)(function () {
    return children.filter(function (c) {
      return !!c;
    });
  }, [children]);

  var _ref2 = (0, _react.useState)(validChildren[0].props.id),
      _ref3 = _slicedToArray(_ref2, 2),
      activeId = _ref3[0],
      setActiveId = _ref3[1];

  return _react["default"].createElement(_style.StyledTabsContainer, null, _react["default"].createElement(_style.StyledList, null, validChildren.map(function (_ref4) {
    var _ref4$props = _ref4.props,
        id = _ref4$props.id,
        label = _ref4$props.label;
    return label ? _react["default"].createElement(_style.StyledListLabel, {
      key: id
    }, _react["default"].createElement(TabButton, {
      onClick: function onClick() {
        return setActiveId(id);
      },
      active: id === activeId
    }, label)) : null;
  })), _react["default"].createElement(_style.StyledTabsContentBox, null, validChildren.map(function (_ref5) {
    var _ref5$props = _ref5.props,
        id = _ref5$props.id,
        content = _ref5$props.children;
    return _react["default"].createElement(_style.StyledTabsContent, {
      key: id,
      active: id === activeId
    }, content);
  })));
};

exports.Tabs = Tabs;

var Tab = function Tab(_ref6) {
  var children = _ref6.children,
      label = _ref6.label;
  return label ? children : null;
};

exports.Tab = Tab;